import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['Services', 'The Space', 'Collection', 'Contact'];
  return <motion.nav initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'py-4' : 'py-6'}`} data-id="element-113">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-114">
        <div className="glass-panel rounded-full px-6 py-3 flex items-center justify-between" data-id="element-115">
          <a href="#" className="font-syncopate font-bold text-lg tracking-wider text-black" data-id="element-116">
            GLOSS & CHROME
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-117">
            <div className="flex space-x-6" data-id="element-118">
              {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} className="text-sm font-medium text-black/70 hover:text-black transition-colors" data-id="element-119">
                  {link}
                </a>)}
            </div>
            <button className="bg-iridescent text-black font-semibold text-xs tracking-widest uppercase px-6 py-2.5 rounded-full animate-pulse-glow hover:scale-105 transition-transform" data-id="element-120">
              Book Now
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-black" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-121">
            {isMobileMenuOpen ? <X size={24} data-id="element-122" /> : <Menu size={24} data-id="element-123" />}
          </button>
        </div>

        {/* Mobile Nav Dropdown */}
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="md:hidden absolute top-full left-6 right-6 mt-2 glass-panel rounded-2xl p-6 flex flex-col space-y-4" data-id="element-124">
            {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} className="text-base font-medium text-black/80 hover:text-black transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-125">
                {link}
              </a>)}
            <button className="bg-iridescent text-black font-semibold text-sm tracking-widest uppercase px-6 py-3 rounded-full mt-4 w-full" data-id="element-126">
              Book Now
            </button>
          </motion.div>}
      </div>
    </motion.nav>;
}